module.exports = __webpack_public_path__ + "img/595356_CDBFC6_AA9DA3_BBB3BC-256px.ee349c8a.png";